'use client';

import React from 'react';
import { ExperienceType } from '../types';
import { typography } from '@/design-system/tokens/typography';
import Border from '../../common/border';

interface ExperienceDescriptionProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceDescription: React.FC<ExperienceDescriptionProps> = ({
  experience,
  type,
}) => {
  if (!experience) return null;

  const getDescription = () => {
    if (type === 'stay') {
      return (
        (experience as { longDescription?: string })?.longDescription || ''
      );
    }
    return (experience as { description?: string })?.description || '';
  };

  const getDescriptionHighlights = (): string[] => {
    const exp = experience as { descriptionHighlights?: string[] };
    return exp?.descriptionHighlights || [];
  };

  const description = getDescription();
  const descriptionHighlights = getDescriptionHighlights();

  if (!description && descriptionHighlights.length === 0) return null;

  return (
    <div className='space-y-4'>
      <h2
        className='font-semibold text-gray-900'
        style={{
          fontSize: typography.size.lg, // 18px
          fontFamily: typography.fonts.primary,
          lineHeight: 'normal',
        }}
      >
        {type === 'package'
          ? 'Travel Story'
          : type === 'stay'
            ? 'Description'
            : 'Tour Description'}
      </h2>
      <div className='max-w-none text-gray-700'>
        {description && (
          <p
            className='whitespace-pre-line mb-9'
            style={{
              fontSize: typography.size.sm, // 14px
              fontFamily: typography.fonts.primary,
              lineHeight: typography.lineHeight.relaxed,
            }}
          >
            {description}
          </p>
        )}
        {descriptionHighlights.length > 0 && (
          <ul
            className='list-disc list-outside mb-7 pl-5 md:pl-6'
            style={{
              fontSize: typography.size.sm, // 14px
              fontFamily: typography.fonts.primary,
            }}
          >
            {descriptionHighlights.map((highlight, index) => (
              <li key={index} className='mb-2.5 leading-relaxed'>
                {highlight}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div>
        <Border />
      </div>
    </div>
  );
};
